module.exports = __webpack_public_path__ + "static/img/01_01.6fbc3ff0.jpg";